import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AllowedCompaniesUpdate from '../allowed-companies/allowed-companies-update';
import DeviceCommunication from './device-communication';
import DeviceCommunicationDeleteDialog from './device-communication-delete-dialog';
import DeviceCommunicationUpdate from './device-communication-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={DeviceCommunicationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={DeviceCommunicationUpdate} />
      {/* <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={DeviceCommunicationDetail} /> */}
      <ErrorBoundaryRoute exact path={`${match.url}/allowed-companies/new`} component={AllowedCompaniesUpdate} />
      <ErrorBoundaryRoute path={match.url} component={DeviceCommunication} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={DeviceCommunicationDeleteDialog} />
  </>
);

export default Routes;
